const INTENT_ID_KEY = 'pendingSetupIntentId';
const CLIENT_SECRET_KEY = 'pendingSetupClientSecret';

export function savePendingSetupIntent(setupIntentId, clientSecret) {
  if (setupIntentId) {
    sessionStorage.setItem(INTENT_ID_KEY, setupIntentId);
  }
  if (clientSecret) {
    sessionStorage.setItem(CLIENT_SECRET_KEY, clientSecret);
  }
}

export function getPendingSetupIntentId() {
  return sessionStorage.getItem(INTENT_ID_KEY) || '';
}

export function getPendingSetupClientSecret() {
  return sessionStorage.getItem(CLIENT_SECRET_KEY) || '';
}

export function clearPendingSetupIntent() {
  sessionStorage.removeItem(INTENT_ID_KEY);
  sessionStorage.removeItem(CLIENT_SECRET_KEY);
}
